import { BehaviorSubject } from "rxjs";

const APP_PREFIX = 'cqes-';

export class LocalStorageService {
  constructor() { }

  setItem(key: string, value: any) {
    localStorage.setItem(`${APP_PREFIX}${key}`, JSON.stringify(value));
  }

  getItem(key: string) {
    return JSON.parse(localStorage.getItem(`${APP_PREFIX}${key}`));
  }
}

export class SessionStorageService {

  businessAccountId = new BehaviorSubject<any>(null);
  constructor() { }

  setItem(key: string, value: any) {
    sessionStorage.setItem(`${APP_PREFIX}${key}`, JSON.stringify(value));
  }

  getItem(key: string) {
    return JSON.parse(sessionStorage.getItem(`${APP_PREFIX}${key}`));
  }
  setRootItem(key: string, value: any) {
    sessionStorage.setItem(`${key}`, JSON.stringify(value));
  }
  getRootItem(key: string) {
    return JSON.parse(sessionStorage.getItem(`${key}`));
  }
  clear() {
    sessionStorage.setItem(null, null);
    sessionStorage.remove('cqes-loginEventData');
  }
}
